import { render, staticRenderFns } from "./UserAddNew.vue?vue&type=template&id=18e5f7ba&scoped=true&"
import script from "./UserAddNew.vue?vue&type=script&lang=js&"
export * from "./UserAddNew.vue?vue&type=script&lang=js&"
import style0 from "./UserAddNew.vue?vue&type=style&index=0&id=18e5f7ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5f7ba",
  null
  
)

export default component.exports